'use client';

import React, { useEffect } from 'react';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import TravelPortalSearchPageHeader from './travelportal-search-page-header/travelportal-search-page-header';
import TravelPortalSearchPageResults from './travelportal-search-page-results/travelportal-search-page-results';

export interface TravelPortalSearchProps {
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Search settings for filters and search bar */
  searchSettings: Content.Components['TravelPortalSearchSettingsDto'];
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const TravelPortalSearch = ({
  personalizationData,
  searchSettings,
  trackingData,
}: TravelPortalSearchProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'travelportal_search_result' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <TravelPortalSearchPageHeader searchSettings={searchSettings} />

      <TravelPortalSearchPageResults searchSettings={searchSettings} />
    </React.Fragment>
  );
};

TravelPortalSearch.displayName = 'TravelPortalSearch';

export default TravelPortalSearch;
